import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, Loader2 } from "lucide-react";

export default function AdminPatients() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(async () => {
      setLoading(true);
      const { data } = await api.get("/admin/patients", { params: { q } });
      setItems(data); setLoading(false);
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center gap-3">
        <h1 className="text-3xl font-bold text-slate-900">Patients</h1>
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="pl-9 rounded-xl h-11 w-64" />
        </div>
      </div>
      <div className="doccare-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left"><tr>
            <th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3 hidden md:table-cell">Phone</th><th className="p-3 hidden md:table-cell">Joined</th>
          </tr></thead>
          <tbody>
            {loading && <tr><td colSpan={4} className="p-8 text-center"><Loader2 className="w-5 h-5 mx-auto animate-spin text-slate-400" /></td></tr>}
            {!loading && items.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-slate-500">No patients</td></tr>}
            {items.map((p) => (
              <tr key={p.id} className="border-t border-slate-100">
                <td className="p-3 font-semibold">{p.name}</td>
                <td className="p-3 text-slate-600">{p.email}</td>
                <td className="p-3 hidden md:table-cell text-slate-600">{p.phone || "—"}</td>
                <td className="p-3 hidden md:table-cell text-slate-500">{p.created_at ? new Date(p.created_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
